import React from 'react';
import { Pressable, Text } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import { useFeedback } from './FeedbackContext';
import { makeStyles } from './style';
import Icon from '../Icon';

export default function FeedbackEntry({ compact = false }: { compact?: boolean }) {
  const { available, open } = useFeedback();
  const styles = makeStyles(useTheme());
  if (!available) return null;
  return <Pressable accessibilityRole="button" accessibilityLabel="Send feedback" onPress={() => open()} style={styles.entry}>{compact ? <Icon icon={['fad', 'comment']} size={18} color={styles.entryText.color} /> : <Text style={styles.entryText}>Feedback</Text>}</Pressable>;
}
